export default __webpack_public_path__ + "static/media/logo.1b744b1b.svg";